export default __webpack_public_path__ + "static/media/IMG_3968.b8c2ea45.jpeg";